// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateBrazilianAddress(addressValue: string): ?UserInputValidationError {
  return addressValue && addressValue.length > 0 ? undefined : { id: 'empty' };
}
